export default __webpack_public_path__ + "static/media/coach-white.cda5bf17.svg";